<template>
    <div class="payment-success">
        <SuccessIllustration :success="success" />
        <div v-if="success === 'no-limit'" class="payment-success__inner">
            <h3 class="payment-success__title">{{ $t('payment.thanks') }}</h3>
            <div class="payment-success__text" v-html="$t('payment.successNoLimit')" />
            <div class="payment-success__notice">
                {{ $t('payment.haveQuestions') }}
                <a href="mailto:hello@speechki.org" class="link">
                    hello@speechki.org
                </a>
            </div>
            <div class="payment-success__ok">
                <button
                    type="button"
                    class="button button--big payment__button"
                    @click.prevent="ok"
                >
                    {{ $t('payment.ok') }}
                </button>
            </div>
        </div>
        <div v-if="success === 'has-limit'">
            <h3 class="payment-success__title">
                {{ $t('payment.successPayment') }}
            </h3>
            <div class="payment-success__text">
                {{ $t('payment.thankYou') }}
            </div>
            <div
                class="payment-success__text payment-success__text--small"
                v-html="$t('payment.useEditor')"
            />
            <div class="payment-success__notice">
                {{ $t('payment.haveQuestions') }}
                <a href="mailto:hello@speechki.org" class="link">
                    hello@speechki.org
                </a>
            </div>
            <div class="payment-success__ok">
                <button
                    type="button"
                    class="button button--big payment__button"
                    @click.prevent="$emit('ok')"
                >
                    {{ $t('payment.ok') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SuccessIllustration from './SuccessIllustration';

export default {
    name: 'PaymentSuccess',
    components: {
        SuccessIllustration
    },
    props: {
        success: {
            type: String,
            required: true
        }
    }
};
</script>
